export default __webpack_public_path__ + "static/telemedicine-18b4d44a727294a301bee47cdf134d14.png";